var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.831,
    height: 20.246,
    viewBox: "0 0 19.831 20.246",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-government-4146735",
    transform: "translate(-5.992 -5.142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20830",
    "data-name": "Path 20830",
    d: "M15.907,5.252,6.092,9.763v2.259H25.723V9.763Zm0,.626,9.244,4.251v1.318H6.663V10.129Z",
    transform: "translate(0 0)",
    fill: "#314286",
    stroke: "#314286",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20831",
    "data-name": "Path 20831",
    d: "M14.973,34.293h.572v9.791h-.572Z",
    transform: "translate(-6.641 -21.715)",
    fill: "#314286",
    stroke: "#314286",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20832",
    "data-name": "Path 20832",
    d: "M22.654,34.293h.572v9.791h-.572Z",
    transform: "translate(-12.384 -21.715)",
    fill: "#314286",
    stroke: "#314286",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20833",
    "data-name": "Path 20833",
    d: "M65.076,34.293h.572v9.791h-.572Z",
    transform: "translate(-44.104 -21.715)",
    fill: "#314286",
    stroke: "#314286",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20834",
    "data-name": "Path 20834",
    d: "M72.764,34.293h.572v9.791h-.572Z",
    transform: "translate(-49.853 -21.715)",
    fill: "#314286",
    stroke: "#314286",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20835",
    "data-name": "Path 20835",
    d: "M6.092,77.681H25.723V75.32H6.092Zm.571-1.789H25.151V77.11H6.663Z",
    transform: "translate(0 -52.392)",
    fill: "#314286",
    stroke: "#314286",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20836",
    "data-name": "Path 20836",
    d: "M36.525,38.664a2.139,2.139,0,1,0,2.137-2.131A2.138,2.138,0,0,0,36.525,38.664Zm3.7,0A1.566,1.566,0,1,1,38.662,37.1,1.559,1.559,0,0,1,40.229,38.664Z",
    transform: "translate(-22.756 -23.39)",
    fill: "#ed3237",
    stroke: "#ed3237",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20837",
    "data-name": "Path 20837",
    d: "M31.572,59.225v-.287a3.7,3.7,0,0,1,1.686-3.149,3.193,3.193,0,0,1,3.4,0,3.7,3.7,0,0,1,1.685,3.149v.287Zm.643-.571H37.7a3.081,3.081,0,0,0-1.346-2.378,2.608,2.608,0,0,0-2.8,0,3.086,3.086,0,0,0-1.347,2.378",
    transform: "translate(-19.052 -37.421)",
    fill: "#ed3237",
    stroke: "#ed3237",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.cca148a313b723c6660c38ed743b66a9.svg";
export { ForwardRef as ReactComponent };